import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Optional,
  Output }                         from '@angular/core';
import { AbstractControl, NgForm } from '@angular/forms';

@Directive({
  selector: 'form[formSubmitValidator]'
})
export class FormSubmitValidatorDirective {
  @Output('formSubmitValidator') onSubmit = new EventEmitter<NgForm>();

  constructor(
    private el    : ElementRef<HTMLFormElement>,
    @Optional()
    private ngForm: NgForm
  ) {}

  @HostListener('submit', [ '$event' ])
  handleSubmit ( event : Event ) : void {
    event.preventDefault();
    event.stopPropagation();

    const control = this.ngForm.control;

    if ( !control ) {
      this.onSubmit.emit(this.ngForm);

      return;
    }

    control.markAllAsTouched();

    this.markAllDirty(control);

    control.updateValueAndValidity({
      onlySelf: false
    });

    if ( control.valid ) {
      this.onSubmit.emit(this.ngForm);

      return;
    }

    this.focusInvalidControl();
  }

  focusInvalidControl () : void {
    const formElement : HTMLFormElement           = this.el.nativeElement;
    const firstInvalidControl: HTMLElement | null = formElement.querySelector('.ng-invalid');

    if ( firstInvalidControl ) {
      firstInvalidControl.scrollIntoView({
        behavior: 'smooth',
        block   : 'center'
      });

      firstInvalidControl.focus({
        preventScroll: true
      });
    }
  }

  markAllDirty ( control : AbstractControl ) : void {
    control.markAsDirty();

    const group = control as any;

    if ( group?.controls ) {
      Object.values(group.controls)
        .forEach(( ctrl : AbstractControl ) => this.markAllDirty(ctrl));
    }
  }
}
